import { render, staticRenderFns } from "./layout-picker.vue?vue&type=template&id=3722b5b6&"
import script from "./layout-picker.vue?vue&type=script&lang=js&"
export * from "./layout-picker.vue?vue&type=script&lang=js&"
import style0 from "./layout-picker.vue?vue&type=style&index=0&id=3722b5b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports